import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tax-param-block',
  templateUrl: './param-block.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParamBlockComponent {
  // @ts-ignore
  @Input() title: string;
  // @ts-ignore
  @Input() placeholder: string | null;
  // @ts-ignore
  @Input() details: string | null;
  // @ts-ignore
  @Input() modalId: string;
  @Output() createModal: EventEmitter<string> = new EventEmitter<string>();

  callCreateModal(modalId: string): void {
    this.createModal.emit(modalId);
  }
}
